import React, { useEffect, useState } from "react";
import { Button } from "@my-scoot/component-library-legacy";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import classnames from "classnames";
import {
  app_route_ids,
  app_route_keys,
  app_route_titles,
} from "constants/urlPaths";
import useDesktopMediaQuery from "hooks/useDesktopMediaQuery";
import { useListController } from "react-admin";
import { Tabs } from "@my-scoot/component-library-legacy";
import ExlyTableFilters from "common/Components/ExlyTable/ExlyTableFilters";
import { is_empty } from "utils/validations";
import { MobileFooter } from "common/Components/MobileFooter";
import { ThankYouPagesListItemCard } from "features/ThankYouPages/modules/ThankYouPagesListItemCard/ThankYouPagesListItemCard";
import { ThankYouPagesListItemCardShimmer } from "features/ThankYouPages/modules/ThankYouPagesListItemCard/modules/ThankYouPagesListItemCardShimmer";
import { Pagination } from "common/Components/Pagination";
import { Header } from "common/Components/Header";
import { getParamValueFromRouteProps } from "utils/Utils";
import ExlyFilteredEmptyState from "common/Components/ExlyTable/ExlyTableFilters/ExlyTableFilterEmptyState";
import {
  thank_you_page_home_stage_filter_key,
  UTM_SRC_URL_PARAMS_KEY,
} from "features/ThankYouPages/constants/ThankYouPages.constants";
import useHideNavAndAppBar from "hooks/useHideNavAndAppBar";
import useAppLayoutControl from "hooks/useAppLayoutControl";
import {
  default_thank_you_page_home_stage_id,
  filterChipFormatter,
  filterConfig,
  thank_you_page_home_tabs,
  thank_you_page_home_tabs_list,
} from "./constants";
import { getRAUrlParams } from "features/Common/utils/url.utils";

const ThankYouPagesHomeBase = (props) => {
  const history = props.history;
  const isDesktop = useDesktopMediaQuery();
  const utmSrc = getRAUrlParams()?.get(UTM_SRC_URL_PARAMS_KEY);
  const defaultStageFilterValue =
    JSON.parse(getParamValueFromRouteProps(props, "filter") || "{}")[
      thank_you_page_home_stage_filter_key
    ] ?? default_thank_you_page_home_stage_id;

  const listControllerData = useListController({
    ...props,
    filterDefaultValues: {
      [thank_you_page_home_stage_filter_key]: defaultStageFilterValue,
    },
  });
  const { data, loading, page, total, setPage, setFilters, filterValues } =
    listControllerData;

  const [loadingWithDelay, setLoadingWithDelay] = useState(false);
  useEffect(() => {
    if (loading) {
      setLoadingWithDelay(true);
    } else {
      setTimeout(() => setLoadingWithDelay(false), 300);
    }
  }, [loading]);

  useEffect(() => {
    if (utmSrc) {
      setFilters({ ...filterValues, utm_source: utmSrc });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [utmSrc]);

  const dataList = Object.keys(data).map((i) => data[i]);

  const handleCreateThankYouPage = () => {
    history.push(app_route_ids[app_route_keys.thank_you_pages_create]);
  };

  const CreateThankYouPageButton = (props) => (
    <Button onClick={handleCreateThankYouPage} {...props}>
      Create Thank You Page
    </Button>
  );

  const [currentTab, setCurrentTab] = useState(
    thank_you_page_home_tabs[
      filterValues[thank_you_page_home_stage_filter_key] ??
        defaultStageFilterValue
    ].priority
  );

  const handleTabChange = (e, index) => {
    const newVal = thank_you_page_home_tabs_list[index].id;
    if (currentTab !== index) {
      setFilters({ [thank_you_page_home_stage_filter_key]: newVal });
      setCurrentTab(index);
    }
  };

  const onBackClick = () => {
    history.push(app_route_ids[app_route_keys.app_home]);
  };

  useHideNavAndAppBar(
    app_route_titles[app_route_keys.thank_you_pages_home],
    onBackClick
  );
  useAppLayoutControl({ values: {} });

  const {
    // eslint-disable-next-line no-unused-vars
    [thank_you_page_home_stage_filter_key]: stageFilter,
    ...filterValuesWOStage
  } = filterValues;
  const hasFilterValuesWOStage = !is_empty(Object.keys(filterValuesWOStage));

  return (
    <div className={`dm_font`}>
      {isDesktop ? (
        <Header
          title={app_route_titles[app_route_keys.thank_you_pages_home]}
          classNames={{
            container: classnames(
              "component-wrapper",
              isDesktop ? "border-bottom-0" : ""
            ),
          }}
          onBackClick={onBackClick}
          hideBackButton={isDesktop}
          right={
            <div className="d-flex">
              {isDesktop ? <CreateThankYouPageButton /> : null}
            </div>
          }
        />
      ) : null}
      <div className="component-wrapper">
        <Tabs
          tabs={thank_you_page_home_tabs_list}
          value={currentTab}
          onChange={handleTabChange}
          classes={{ root: "mb-3" }}
        />
        {!is_empty(dataList) || hasFilterValuesWOStage || loadingWithDelay ? (
          <>
            <ExlyTableFilters
              filters={filterConfig}
              tableChipsFormatter={filterChipFormatter}
              setFilters={(value) => {
                const stage = thank_you_page_home_tabs_list[currentTab].id;
                setFilters(
                  Object.assign(value, {
                    [thank_you_page_home_stage_filter_key]: stage,
                  })
                );
              }}
              filterValues={filterValues}
              isDesktop={isDesktop}
              noExportButton
              className="mb-3"
            />
            {!loadingWithDelay && is_empty(dataList) ? (
              <ExlyFilteredEmptyState />
            ) : null}
            <div className="tw-mt-5 md:tw-flex md:tw-flex-col md:tw-gap-4 max-md:tw-grid max-md:tw-grid-cols-[repeat(auto-fit,minmax(250px,1fr))] max-md:tw-gap-x-5 max-md:tw-gap-y-5 max-md:tw-mb-[70px]">
              {loadingWithDelay
                ? [1, 2, 3, 4].map((i) => (
                    <ThankYouPagesListItemCardShimmer key={i} />
                  ))
                : null}
              {!loadingWithDelay && !is_empty(dataList)
                ? dataList.map((i) => (
                    <ThankYouPagesListItemCard key={i.uuid} data={i} />
                  ))
                : null}
            </div>
          </>
        ) : null}

        {!loadingWithDelay && is_empty(dataList) && !hasFilterValuesWOStage ? (
          <div className="tw-text-center tw-py-16">
            <div className="tw-text-xl tw-font-medium tw-mb-2">
              {thank_you_page_home_tabs_list[currentTab].emptyTitle}
            </div>
            <div className="tw-text-sm tw-text-gray-500 tw-mb-6">
              {thank_you_page_home_tabs_list[currentTab].emptySubtitle}
            </div>
            <CreateThankYouPageButton variant="contained" color="primary" />
          </div>
        ) : null}
        <div className={"py-3"} />
        <Pagination page={page} onPageChange={setPage} total={total} />
        <div className={isDesktop ? "" : "my-4 py-3"} />
      </div>
      <MobileFooter>
        <CreateThankYouPageButton fullWidth />
      </MobileFooter>
    </div>
  );
};

export const ThankYouPagesHome = withComponentLibraryTheme(
  ThankYouPagesHomeBase
);
export default ThankYouPagesHome;
